import Typography from '@mui/material/Typography';
import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { useAppContext } from '../Store';
import { RESET_VIEW_DOC } from '../reducer';
import { Stack, Tooltip } from '@mui/material';
import { carriers } from '../constants';
import useHighlightCard from '../hooks/useHighlightCard';

type PropsType = {
  h: any;
  isArchive?: boolean;
  lastResult: boolean;
  disableCardAnchor: boolean;
  headerRef: React.MutableRefObject<HTMLDivElement | null>;
};
type CarrierLabels = { label: string; alt: string };

const ResultCardDetails = ({
  h,
  isArchive,
  lastResult,
  disableCardAnchor,
  headerRef,
}: PropsType) => {
  const { dispatch } = useAppContext();
  let carriersDistinct = new Set([]);
  let carrierLabels: CarrierLabels[] = [];

  const innerhitId = h._id;
  const bu = h._source.bu;
  const opu = h._source.opu;
  const pop = h._source.program_or_product;
  const lob = h._source.line_of_business;
  const typeOfBusiness = h._source.form_type_of_business;

  const ref = useRef<null | HTMLDivElement>(null);
  const { highlightCard } = useHighlightCard(headerRef, innerhitId, disableCardAnchor);

  if (h._source.state_filings && h._source.state_filings.length > 0) {
    carriersDistinct = new Set(h._source.state_filings.map((item: any) => item.carrier));
    carrierLabels = Array.from(carriersDistinct)
      .filter(Boolean)
      .map((item: string) => ({
        label: item,
        alt: carriers.get(item) || '',
      }));
  }

  return (
    <Link
      key={innerhitId}
      to={`/view/${innerhitId}`}
      className="nostyle"
      style={{ width: '100%', pointerEvents: isArchive ? 'none' : 'auto' }}
      onClick={() => dispatch({ type: RESET_VIEW_DOC })}
    >
      <Stack
        padding={'4px 8px'}
        sx={{
          border: `${highlightCard ? '2px solid green' : '1px solid transparent'}`,
          borderBottom: `${!highlightCard && !lastResult && '1px solid rgba(0, 0, 0, 0.12)'}`,
          '&:hover': {
            border: `${!highlightCard && '1px solid black'}`,
          },
        }}
        border={1}
        spacing={4}
        direction={'row'}
        ref={ref}
        id={innerhitId}
      >
        <Typography width={'45%'}>{[bu, opu, pop, lob].join(' | ')}</Typography>
        <Typography width={'8%'}>{typeOfBusiness}</Typography>
        <Stack direction={'row'}>
          {carrierLabels
            .sort((a, b) => (a.label < b.label ? -1 : 1))
            .map((carrierLabel, idx) => (
              <Tooltip title={carrierLabel.alt} key={`${carrierLabel.label}-${idx}`}>
                <Typography>
                  {idx < carrierLabels.length - 1 ? carrierLabel.label + ',' : carrierLabel.label}
                  &nbsp;
                </Typography>
              </Tooltip>
            ))}
        </Stack>
      </Stack>
    </Link>
  );
};

export default ResultCardDetails;
